<script>
import { Article, ProjectTag } from '@/api'
import fields from '@/components/fields/'
import moment from 'moment'
import PageFormBase from '@/crudBases/form/PageFormBase'

export default {
  mixins: [PageFormBase],
  data() {
    return {
      form: {
        widgets: []
      },
      projectTagOptions: [],
      redirectRoute: { name: 'Article List' },
      livePreview: true
    }
  },
  created() {
    this.fetchProjectTags()
    if (this.form.publication_date === undefined) {
      this.$set(this.form, 'publication_date', moment().format('YYYY-MM-DD'))
    }
  },
  methods: {
    fetchProjectTags() {
      const params = { page_size: 'max' }
      ProjectTag.fetch({}, { params }).then(res => {
        this.projectTagOptions = res.data.results.map(item => ({
          label: item.name,
          value: item.name
        }))
      })
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          attrs: {
            value: this.selectedTab
          },
          listeners: {
            input: value => (this.selectedTab = value)
          },
          children: [
            this.getGeneralTab(),
            this.getWidgetsTab(),
            this.getPreviewTab(),
            this.getSEOTab()
          ]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne',
          name: 'general'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            required: true,
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            requiredInAllLanguages: true
          }),
          new fields.Switch({
            label: 'Zmniejszony nagłówek',
            modelPath: [this, 'form', 'is_small_header']
          }),
          new fields.WYSIWYG({
            label: 'Ostylowany tytuł',
            modelPath: [this, 'form', 'styled_title'],
            multilingual: true
          }),
          new fields.Select({
            label: 'Tagi projektu',
            modelPath: [this, 'form', 'project_tags'],
            multiple: true,
            filterable: true,
            allowCreate: true,
            options: this.projectTagOptions
          }),
          new fields.Date({
            label: 'Data projektu',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            modelPath: [this, 'form', 'project_date']
          }),
          new fields.Select({
            modelPath: [this, 'form', 'type'],
            required: true,
            clearable: false,
            label: 'Typ',
            options: [
              { label: 'Case study', value: 'case_study' },
              { label: 'Insight', value: 'insight' },
              { label: 'News', value: 'news' },
              { label: 'Articles', value: 'articles' }
            ]
          }),
          new fields.Image({
            label: 'Zdjęcie główne',
            modelPath: [this, 'form', 'image'],
            required: true
          }),
          new fields.Image({
            label: 'Zdjęcie wewnętrzne',
            modelPath: [this, 'form', 'inner_image']
          }),
          new fields.Input({
            label: 'Autor',
            modelPath: [this, 'form', 'author'],
            multilingual: true
          }),
          new fields.Date({
            label: 'Data publikacji',
            type: 'datetime',
            modelPath: [this, 'form', 'publication_date'],
            required: true
          }),
          new fields.Header({
            text: this.publicationInFutureMessage,
            type: 'p',
            condition: this.publicationInFuture
          }),
          new fields.Switch({
            label: 'Data ukryta',
            modelPath: [this, 'form', 'is_date_hidden']
          }),
          new fields.Switch({
            label: 'Ukryj na liście',
            modelPath: [this, 'form', 'hide_on_list']
          })
        ]
      }
    },
    getWidgetsTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Widgety'
        },
        children: [new fields.Widgets({ modelPath: [this, 'form', 'widgets'] })]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return Article
    },
    livePreviewUrl() {
      return '/preview/articles/'
    },
    publicationInFutureMessage() {
      if (!this.publicationInFuture) {
        return ''
      }
      const givenDate = moment(this.form.publication_date)
      return `Artykuł będzie dostępny dla użytkowników
           ${givenDate.format('DD/MM/YYYY')}
           o godzinie: ${givenDate.format('HH:mm')}`
    },
    publicationInFuture() {
      if (!this.form.publication_date) {
        return false
      }
      return moment().isBefore(this.form.publication_date)
    }
  },
  watch: {
    'form.publication_date'() {
      this.form.is_hidden = this.publicationInFuture
    }
  }
}
</script>
